import Navigation from "../../header";
import { Container } from "@mui/material";
import { PowerBIEmbed } from 'powerbi-client-react';
import { IEmbedConfiguration, models } from 'powerbi-client';
import PermissionGate from "../../permissionGate";
import { useUserContext } from "../../../contexts/userContext";

const MaterialPricingReport = () => {
	var userContext = useUserContext();

	return (
		<>
			<Navigation></Navigation>
			<Container maxWidth="lg" className="route-container">
				<PermissionGate permission={userContext?.permissions?.canViewReportMaterialPricing}>
					<h1 className="report-header">Material Pricing Report</h1>
					{/* <iframe role="presentation" width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=c83f2f5b-ac55-4667-add0-1dbe9bef7393&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi" frameBorder="1"></iframe> */}
					{/* The following embed allows you to set the parameters from the page, not just in the report. You will need this later.
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=c83f2f5b-ac55-4667-add0-1dbe9bef7393&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi&rp:Customer=2588"></embed> */}
					<embed width="1200" height="800" src="https://app.powerbi.com/rdlEmbed?reportId=c83f2f5b-ac55-4667-add0-1dbe9bef7393&autoAuth=true&ctid=3d903043-2b47-4eb6-ba60-a27fe7950ef2&experience=power-bi"></embed>
				</PermissionGate>
			</Container>
		</>
	);
};

export default MaterialPricingReport;